export default "__VITE_ASSET__Bb73kuz1__"